module.exports = __webpack_public_path__ + "files/SPIADI2025 - Journée Nationale - Programme.1d6261fc9b4a7f490037d388d7099693.pdf";